import React, { useEffect } from 'react';
import { renderInputField } from '../../../common/inputField';
import { useDispatch, useSelector } from 'react-redux';
import {
  getPatientDetailsApi,
  updatePatientColumnApi,
} from '../../../api/patientApi';
import { useParams } from 'react-router-dom';
import { setPatientData, setSelectedPatientData } from '../../../actions';
import DateComponent from '../../Registrationform/components/dateComponent';
import dayjs from 'dayjs';

const GeneralDetails = () => {
  const dispatch = useDispatch();
  const selectedPatientData = useSelector(
    (state) => state.clinicalReducer.selectedPatientData,
  );
  const patientData = useSelector(
    (state) => state.clinicalReducer.patientDetails,
  );

  const params = useParams();
  useEffect(() => {
    const fetchPatientDetails = async () => {
      if (selectedPatientData && !selectedPatientData.isFetched) {
        const response = await getPatientDetailsApi(params.id);
        dispatch(setSelectedPatientData(response.data));
      }
    };

    fetchPatientDetails();
  }, [params, selectedPatientData.isFetched, dispatch]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(setPatientData(`patientDetails.${name}`, value));
  };

  console.log(`patientData`, patientData);

  return (
    <>
      <div className="theme-blush">
        <div className="container-fluid">
          <div className="card">
            <div className="header">
              <p className="lead">General Details</p>
            </div>

            <div className="body">
              <div className="card_name_container">
                {renderInputField(
                  "Wife's Name",
                  'wifeName',
                  patientData.wifeName,
                  handleInputChange,
                  false,
                  '',
                  true,
                )}
                {renderInputField(
                  'Occupation',
                  'wifeOccupation',
                  patientData.wifeOccupation,
                  handleInputChange,
                  false,

                  '',

                  true,
                )}

                {renderInputField(
                  'Age',
                  'wifeAge',
                  patientData.wifeAge,
                  handleInputChange,
                  false,

                  '',

                  true,
                )}
                {renderInputField(
                  'MPI No',
                  'upid',
                  selectedPatientData.patient.upid,
                  handleInputChange,
                  false,
                  '',
                  true,
                )}
                {renderInputField(
                  'BMI',
                  'patientBMI',
                  patientData.patientBMI,
                  handleInputChange,
                )}
              </div>

              <div className="card_name_container">
                {renderInputField(
                  "Husband's Name",
                  'husbandName',
                  patientData.husbandName,
                  handleInputChange,
                  false,

                  '',

                  true,
                )}
                {renderInputField(
                  'Occupation',
                  'husbandOccupation',
                  patientData.husbandOccupation,
                  handleInputChange,
                  false,

                  '',

                  true,
                )}

                {renderInputField(
                  'Age',
                  'husbandAge',
                  patientData.husbandAge,
                  handleInputChange,
                  false,

                  '',

                  true,
                )}
                {renderInputField(
                  'MPI No',
                  'upid',
                  selectedPatientData.patient.upid,
                  handleInputChange,
                  false,
                  '',
                  true,
                )}
                {renderInputField(
                  'BMI',
                  'partnerBMI',
                  patientData.partnerBMI,
                  handleInputChange,
                )}
              </div>

              <div className="card_name_container">
                {renderInputField(
                  'Address',
                  'address',
                  selectedPatientData.patient.address,
                  handleInputChange,
                  false,

                  '',

                  true,
                )}
                {renderInputField(
                  'Phone',
                  'phone',
                  selectedPatientData.patient.phone,
                  handleInputChange,
                  false,

                  '',

                  true,
                )}
                {renderInputField(
                  'Referred By',
                  'referredBy',
                  selectedPatientData.patient?.referral?.referringPhysician,
                  handleInputChange,
                  false,

                  '',

                  true,
                )}
                <div>
                  <label>Date</label>
                  <DateComponent
                    selectedDate={
                      patientData.registrationDate
                        ? dayjs(patientData.registrationDate)
                        : null
                    }
                    isDisabled={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GeneralDetails;
